<template>
  <div v-click-outside="outsideCancelAction" class="allScreen">
    <v-form fast-fail @submit.prevent="saveData" class="settings-partner">
      <v-row no-gutters>
        <v-col cols="6" sm="4">
          <v-select
            :label="$t('settingsPartnerPopperComponent.labels.serviceProvider')"
            :items="serviceProviders"
            item-title="value"
            item-value="key"
            v-model="userData.serviceProvider"
            name="service_provider"
            id="service_provider"
            variant="outlined"
            @update:modelValue="getSettingsMethod"
          ></v-select>
        </v-col>
        <v-col
          v-if="['cmfx', 'szamlazz_hu'].includes(userData.serviceProvider)"
          cols="1"
          style="margin-left: auto"
        >
          <v-checkbox label="Default" v-model="isDefault"></v-checkbox>
        </v-col>
      </v-row>

      <div v-if="!isLoading">
        <!-- SIMPLE -->
        <v-row
          v-if="userData.serviceProvider === SERVICE_PROVIDER_VALUES.SIMPLE"
        >
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="userData.simple_api_merchant_key"
              :label="
                $t('settingsPartnerPopperComponent.labels.simpleAPIMerchantKey')
              "
              name="simple_api_merchant_key"
              id="simple_api_merchant_key"
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="userData.simple_api_merchant"
              :label="
                $t('settingsPartnerPopperComponent.labels.simpleAPIMerchant')
              "
              name="simple_api_merchant"
              id="simple_api_merchant"
              variant="outlined"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- BARION -->
        <v-row
          v-if="userData.serviceProvider === SERVICE_PROVIDER_VALUES.BARION"
        >
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="userData.barion_api_poskey"
              :label="
                $t('settingsPartnerPopperComponent.labels.barion_api_poskey')
              "
              name="barion_api_poskey"
              id="barion_api_poskey"
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="userData.barion_api_payee_email"
              :label="
                $t(
                  'settingsPartnerPopperComponent.labels.barion_api_payee_email'
                )
              "
              name="barion_api_payee_email"
              id="barion_api_payee_email"
              variant="outlined"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- CMFX -->
        <div v-if="userData.serviceProvider === SERVICE_PROVIDER_VALUES.CMFX">
          <v-row>
            <v-col cols="12" sm="6" class="pb-0">
              <v-text-field
                v-model="userData.cmfx_url"
                :label="$t('settingsPartnerPopperComponent.labels.cmfxURL')"
                name="url"
                id="url"
                variant="outlined"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-text-field
                v-model="userData.cmfx_csoport"
                :label="$t('settingsPartnerPopperComponent.labels.cmfxGroup')"
                name="group"
                id="group"
                variant="outlined"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="userData.cmfx_user"
                :label="$t('settingsPartnerPopperComponent.labels.cmfxUser')"
                name="email"
                id="email"
                variant="outlined"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                type="password"
                v-model="userData.cmfx_password"
                :label="
                  $t('settingsPartnerPopperComponent.labels.cmfxPassword')
                "
                name="password"
                id="password"
                variant="outlined"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <!-- SZAMLAZZ_HU -->
        <div
          v-if="
            userData.serviceProvider === SERVICE_PROVIDER_VALUES.SZAMLAZZ_HU
          "
        >
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="userData.szamlazz_hu_invoice_agent_key"
                :label="
                  $t(
                    'settingsPartnerPopperComponent.labels.szamlazz_hu_invoice_agent_key'
                  )
                "
                name=" szamlazz_hu_invoice_agent_key"
                id=" szamlazz_hu_invoice_agent_key"
                variant="outlined"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- SZEP_CARD -->
      <v-row
        v-if="userData.serviceProvider === SERVICE_PROVIDER_VALUES.SZEP_CARD"
      >
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="userData.szep_card_api_merchant_key"
            :label="
              $t('settingsPartnerPopperComponent.labels.szepCardMerchantKey')
            "
            name="szep_card_api_merchant_key"
            id="szep_card_api_merchant_key"
            variant="outlined"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="userData.szep_card_api_merchant"
            :label="
              $t('settingsPartnerPopperComponent.labels.szepCardMerchant')
            "
            name="szep_card_api_merchant"
            id="szep_card_api_merchant"
            variant="outlined"
          ></v-text-field>
        </v-col>
      </v-row>

      <div v-else class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </div>
    </v-form>

    <div v-if="userData.serviceProvider" class="btn-row">
      <v-btn @click="cancelAction">
        {{ $t("profile.cancel") }}
      </v-btn>
      <v-btn color="red" @click="handleDelete" :disabled="!hasSettings">
        {{ $t("profile.delete") }}
      </v-btn>
      <v-btn color="primary" @click="hasSettings ? updateData() : saveData()">
        {{ $t("profile.save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { PAYMENT_PROVIDER, INVOICE_PROVIDER } from "@/components/enums";
import { SERVICE_PROVIDER_VALUES } from "@/components/enums";

import { mapActions } from "vuex";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "SettingsPartnerPopper",
  components: {},
  props: {
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      userData: {
        serviceProvider: null,

        simple_api_merchant_key: "",
        simple_api_merchant: "",

        szep_card_api_merchant_key: "",
        szep_card_api_merchant: "",
      },
      serviceProviders: [
        {
          key: PAYMENT_PROVIDER.SIMPLE,
          value: this.$t(`enums.serviceProvider.${PAYMENT_PROVIDER.SIMPLE}`),
        },
        {
          key: PAYMENT_PROVIDER.SZEP_CARD,
          value: this.$t(`enums.serviceProvider.${PAYMENT_PROVIDER.SZEP_CARD}`),
        },
        {
          key: INVOICE_PROVIDER.SZAMLAZZ_HU,
          value: this.$t(
            `enums.serviceProvider.${INVOICE_PROVIDER.SZAMLAZZ_HU}`
          ),
        },
      ],
      hasSettings: false,

      copiedUserData: {},
      isLoading: false,

      isDefault: false,
      SERVICE_PROVIDER_VALUES,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    ...mapActions({
      getSettingsForProvider: "users/getSettingsForProvider",
      createSettingsForProvider: "users/createSettingsForProvider",
      updateSettingsForProvider: "users/updateSettingsForProvider",
      deleteSettingsForProvider: "users/deleteSettingsForProvider",
    }),

    updateSimpleApiMerchant(newValue) {
      this.userData.simple_api_merchant = newValue;
    },

    getSettingsMethod() {
      this.isLoading = true;
      const payload = {
        id: this.user.id,
        par_id: this.user.id,
        provider: this.userData.serviceProvider,
      };

      this.getSettingsForProvider(payload)
        .then((res) => {
          if (!res.partner_setting_not_found) {
            this.hasSettings = true;
            try {
              this.isDefault = res.default;
              const parsedData = JSON.parse(res.data);
              this.userData = {
                ...this.userData,
                ...parsedData,
              };
              this.copiedUserData = { ...this.userData };
            } catch (error) {
              console.log("Error: ", error);
            }
          } else {
            this.hasSettings = false;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },

    saveData() {
      const requestBody = {
        id: this.user.id,
        data:
          this.userData.serviceProvider === SERVICE_PROVIDER_VALUES.SIMPLE
            ? {
                simple_api_merchant: this.userData.simple_api_merchant,
                simple_api_merchant_key: this.userData.simple_api_merchant_key,
              }
            : this.userData.serviceProvider === SERVICE_PROVIDER_VALUES.BARION
            ? {
                barion_api_payee_email: this.userData.barion_api_payee_email,
                barion_api_poskey: this.userData.barion_api_poskey,
              }
            : this.userData.serviceProvider === SERVICE_PROVIDER_VALUES.CMFX
            ? {
                cmfx_url: this.userData.cmfx_url,
                cmfx_csoport: this.userData.cmfx_csoport,
                cmfx_user: this.userData.cmfx_user,
                cmfx_password: this.userData.cmfx_password,
              }
            : this.userData.serviceProvider ===
              SERVICE_PROVIDER_VALUES.SZAMLAZZ_HU
            ? {
                szamlazz_hu_username: this.userData.szamlazz_hu_username,
                szamlazz_hu_password: this.userData.szamlazz_hu_password,
                szamlazz_hu_invoice_agent_key:
                  this.userData.szamlazz_hu_invoice_agent_key,
              }
            : this.userData.serviceProvider ===
              SERVICE_PROVIDER_VALUES.SZEP_CARD
            ? {
                szep_card_api_merchant_key:
                  this.userData.szep_card_api_merchant_key,
                szep_card_api_merchant: this.userData.szep_card_api_merchant,
              }
            : {},
        provider: this.userData.serviceProvider,
        default: this.isDefault,
      };

      this.createSettingsForProvider(requestBody)
        .then(() => {
          toast.success(
            this.$t("settingsPartnerPopperComponent.toast.successCreate")
          );
          this.emitter.emit("closePopper");
        })
        .catch((err) => {
          console.log(err), this.emitter.emit("closePopper");
        });
    },

    updateData() {
      const requestBody = {
        id: this.user.id,
        provider: this.userData.serviceProvider,
        default: this.isDefault,
      };

      const differentDatas = Object.keys(this.copiedUserData).reduce(
        (result, key) => {
          if (this.copiedUserData[key] !== this.userData[key]) {
            result[key] = this.userData[key];
          }
          return result;
        },
        {}
      );

      Object.assign(requestBody, differentDatas);

      this.updateSettingsForProvider(requestBody)
        .then(() => {
          this.emitter.emit("closePopper");
          toast.success(
            this.$t("settingsPartnerPopperComponent.toast.successEdit")
          );
        })
        .catch((err) => console.log(err));
    },

    handleDelete() {
      const payload = {
        id: this.user.id,
        par_id: String(this.user.id),
        provider: this.userData.serviceProvider,
      };

      this.deleteSettingsForProvider(payload)
        .then(() => {
          this.getSettingsMethod();
          this.emitter.emit("closePopper");
          toast.success(
            this.$t("settingsPartnerPopperComponent.toast.successDelete")
          );
        })
        .catch((err) => console.log(err));
    },

    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closePopper");
      }
    },
    outsideCancelAction(event) {
      const clickedElement = event.target;
      const classList = clickedElement.classList;

      if (classList.contains("v-overlay__scrim")) {
        this.cancelAction();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.allScreen {
  height: 100%;
}
.logo {
  max-width: 150px;
  height: auto;
}
::v-deep(.v-input__prepend img) {
  max-width: 50px;
  height: auto;
}

.logo-input {
  ::v-deep(.v-field__input) {
    display: block;
  }
}
.settings-partner {
  padding: 8px 32px;
  .left-side {
    width: 50%;
    padding: 32px;
    .v-text-field {
      margin-top: 12px;
    }
  }
  .right-side {
    width: 50%;
    padding: 32px;
    .vat-input {
      margin-top: 0px !important;
    }
    .v-text-field {
      margin-top: 12px;
    }
    .v-select {
      margin-top: 12px;
    }
  }
}
.btn-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .v-btn {
    width: 220px;
  }
}

@media (max-width: 750px) {
  .btn-row {
    .v-btn {
      width: 160px;
    }
  }
}

@media (max-width: 680px) {
  .settings-partner {
    flex-direction: column;
    padding: 8px 12px;
    .left-side {
      width: 100%;
      padding-bottom: 0;
    }
    .right-side {
      padding-top: 0;
      width: 100%;
    }
  }
  .btn-row {
    flex-direction: column-reverse;
    margin-bottom: 32px;
    padding: 0 44px;
    .v-btn {
      width: 160px;
      margin-bottom: 16px;
      width: 100%;
    }
  }
}
</style>
